export const billingBillStatus = [
  { label: 'Em processamento', value: 'in_process' },
  { label: 'Aguardando pagamento', value: 'pending_payment' },
  { label: 'Pago', value: 'paid' },
  { label: 'Processando pagamento', value: 'processing_payment' },
  { label: 'Parcialmente Pago', value: 'partially_paid' },
  { label: 'Falha no SICOF', value: 'with_integration_failure' },
  { label: 'Não requer pagamento', value: 'payment_not_needed' },
  { label: 'Aguardando autorização de pagamento', value: 'awaiting_payment_confirmation' },
  { label: 'Aguardando autorização de fornecimento', value: 'pending_supply_authorization' },
  { label: 'Aguardando aprovação manual', value: 'awaiting_manual_approval' },
  { label: 'Rejeitado pela empresa', value: 'rejected_by_company' },
  { label: 'Gerando', value: 'draft' },
];
